import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useIntl } from 'react-intl';

import { Grid } from '@mui/material';
import { Switch, Tooltip, Icons, TextArea, Loading } from '@gpstrackit/gtc-react-controls';

import { ContactsSelector } from 'Components';
import Preferences from 'Core/containers/Preferences';
import { getNotesCounterColor, NOTES_MAX_LENGTH } from '../../../../../realtimeMaps/main/components/eta/helpers';




//Actions
import {
    catalogLoad,
    routesEtaSearchEtaLinks
} from 'Redux/actions';

/* const ROUTES_NEW_ROUTE_FORM = {
    //Eta link control
    etaLink: false,
    etaData: {
        etaLinkId: 0,
        shareCamera: false,
        contactsEta: [],
        notes: ''
    },
}; */


const RouteEtaRoutes = (props) => {

    const { formData, setFormData } = props
    const { messages, locale } = useIntl();

    const loading = useSelector(state => state.routesManagerEditPanelRouteEtaRoutesRedux?.loading);
    const contacts = useSelector(state => state.catalogsRedux.contacts);
    const loadingContacts = useSelector(state => state.catalogsRedux.loadingContacts);

    //Refs
    const preferencesRef = useRef();

    const dispatch = useDispatch();
    //const [formData, setFormData] = useState({ ...ROUTES_NEW_ETA_FORM });
    const [country, setCountry] = useState(null);

    const handleClose = () => {
        //dispatch(etaCreateEditReset());
        setCountry(null);
        //setFormData({});
        //clearForm();
    }

    return(
        <div>
            <Preferences
                ref={preferencesRef}
                preferencesKey="etaLink"
                onInitialPreferences={(preferences) => {
                    if (preferences?.country) {
                        setCountry(preferences?.country);
                    }
                }}
            >
                <Grid
                    container
                    wrap="nowrap"
                    direction="column"
                    justifyContent="flex-start"
                    alignItems="flex-start"
                    sx={{ gridGap: 30 }}
                >
                    {
                        (loading) 
                        ?
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                <Loading />
                            </div> 
                        :
                            <></>
                    }
                    <Grid item>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <label className={'labelMapSettings'} style={{ fontWeight: 600 }}>
                                {messages['fsmRoute_eta_route_etalink']}
                            </label>
                            <div style={{ paddingLeft: 5}}>
                                <Tooltip
                                    placement="bottom"
                                    title={messages['fsmRoute_eta_route_etalinkInfo']}
                                >
                                    <Icons
                                    
                                    name="help"
                                    //name="info"
                                    size="medium"
                                    />
                                </Tooltip>
                            </div>
                        </div>
                        <Switch 
                            //backgroundColorClass='gtc-rc-blue-switch' 
                            checked={formData?.etaLink || false} 
                            optionLabels={[messages['yes'], messages['no']]}
                            size="large"
                            labelPosition="right"
                            onChange={(value) => {
                                setFormData(formData => ({ ...formData, etaLink: value }));
                                //const routeProperties = { optimized: value , avoidToll: formData?.avoidToll || false  };
                                //dispatch(savePreference("User", authenticatedId, preferencesKey, routeProperties));
                                //update route value

                        }}/>
                    </Grid>
                    {
                        formData?.etaLink
                        &&
                        <Grid
                            container
                            wrap="nowrap"
                            direction="column"
                            justifyContent="flex-start"
                            alignItems="flex-start"
                            sx={{ gridGap: 30 }}
                        >
                            <Grid item>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <label className={'labelMapSettings'} style={{ fontWeight: 400 }}>
                                        {messages['fsmRoute_eta_route_sharecamera']}
                                    </label>
                                    <div style={{ paddingLeft: 5}}>
                                        <Tooltip
                                            placement="bottom"
                                            title={messages['fsmRoute_eta_route_sharecamerainfo']}
                                        >
                                            <Icons
                                            
                                            name="help"
                                            //name="info"
                                            size="medium"
                                            />
                                        </Tooltip>
                                    </div>
                                </div>
                                <Switch 
                                    //backgroundColorClass='gtc-rc-blue-switch' 
                                    checked={formData?.etaData?.shareCamera || false} 
                                    optionLabels={[messages['yes'], messages['no']]}
                                    size="large"
                                    labelPosition="right"
                                    onChange={(value) => {
                                        setFormData(formData => ({ ...formData, etaData: { ...formData.etaData, shareCamera: value }}));
                                        //const routeProperties = { optimized: value , avoidToll: formData?.avoidToll || false  };
                                        //dispatch(savePreference("User", authenticatedId, preferencesKey, routeProperties));
                                        //update route value

                                }}/>
                            </Grid>
                            <Grid item xs={12} style={{ width: '90%'}}>
                                <TextArea
                                    id="etaNotes"
                                    label={messages['fsmRoute_eta_route_recipients_notes']}
                                    maxLength={NOTES_MAX_LENGTH}
                                    minLength={0}
                                    name="TextAreaName"
                                    onChange={(value) => {
                                        setFormData(formData => ({ ...formData, etaData: { ...formData.etaData, notes: value }}));
                                    }}
                                    placeholder={messages['fsmRoute_eta_route_recipients_notesinfo']}
                                    style={{ width: '100%'}}
                                    value={formData?.etaData?.notes}
                                />
                                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: -5 }}>
                                    <span style={{ fontSize: 12, color: getNotesCounterColor(formData?.etaData?.notes?.length || 0) }}>
                                        {formData?.etaData?.notes?.length || 0}/{NOTES_MAX_LENGTH}
                                    </span>
                                </div>
                            </Grid>
                            <Grid item xs={12} style={{ width: '100%'}}>
                                <div
                                    id='divEtaLink'
                                    style={{
                                        width: '100%',
                                        maxWidth: '100%',
                                        boxSizing: 'border-box'
                                    }}
                                >
                                    <h3 style={{ marginBottom: 6 }}>{messages['fsmRoute_eta_route_recipients']}</h3>
                                    <ContactsSelector
                                        label={messages['eta_choose_contact']}
                                        values={formData?.etaData?.contactsEta}
                                        //disabled={loading || (create?.id ? true : false)}
                                        required
                                        styleMax
                                        showLabel
                                        loading={loadingContacts}
                                        country={country}
                                        contacts={contacts?.map(contact => {
                                            return { ...contact, name: contact?.title }
                                        })}
                                        entities={["EMAIL", "SMS", "CONTACT"]}
                                        emailKeyPress={(e) => { e.code === 'Space' && e.preventDefault(); }}
                                        onChange={(values) => {
                                            setFormData(formData => ({ ...formData, etaData: { ...formData.etaData, contactsEta: values}}));
                                        }}
                                        onChangeCountry={(newCountry) => {
                                            preferencesRef?.current?.savePreference("User", "etaLink", { country: newCountry?.code });
                                        }}
                                    />
                                </div>
                            </Grid>
                        </Grid>
                    }
                </Grid>
            </Preferences>
        </div>
    )

}

export default RouteEtaRoutes